import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
 
import { Observable, throwError } from 'rxjs';
 
import { catchError } from 'rxjs/operators';
import { UserToken, TokenResponse } from '../../models/userToken';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { environment } from 'mds-ui/environments/environment';
import { HttpErrorHandler, HandleError } from 'mds-ui/app/shared/service/http-error-handler.service';

@Injectable()
export class JWTService{
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    public jwtToken: TokenResponse = new TokenResponse;
    constructor(private _http: HttpClient,private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('JWTService');  
    }
    
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    getJWTToken(userToken: UserToken): Observable<TokenResponse[]> {
        return this._http.post<TokenResponse[]>( environment.getJWTTokenUrl, userToken, this.httpOptions)
        .pipe(catchError(error=>{return throwError(error);}));
    }
}